<nb-layout>
  <nb-layout-column>
    <div *ngIf="responsiveMode === 'lg'"
         class="d-flex flex-column align-items-center justify-content-center position-relative error-500">
      <div class="m-auto py-5 text-center">
        <img src="assets/images/errors/error-licence.png" alt="" style="width: 80%;">
        <div class="d-flex flex-column align-items-center justify-content-between text-position ">
          <p class="main-text">خطای اشتراک</p>
          <p class="info mb-5 mt-1 type-1">
            دسترسی شما به نرم افزار تارت به دلیل نامعتبر بودن اشتراک محدود شده است.
          </p>
          <p class="description" style="font-size: 16px;">برای رفع مشکل با تیم پشتیبانی تارت ارتباط بگیرید.</p>
        </div>
      </div>
    </div>
    <div *ngIf="responsiveMode === 'md'" class="m-auto">
      <img src="assets/images/errors/error-licence.png" alt="">
      <div class="d-flex flex-column align-items-center justify-content-between">
        <p class="main-text">خطای اشتراک</p>
        <p class="info mb-5 mt-1 type-1">
          دسترسی شما به نرم افزار تارت به دلیل نامعتبر بودن اشتراک محدود شده است.
        </p>
        <p class="description" style="font-size: 16px;">برای رفع مشکل با تیم پشتیبانی تارت ارتباط بگیرید.</p>
      </div>
    </div>
  </nb-layout-column>
</nb-layout>

